"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_CASH_MANAGEMENT_PERMISSIONS = exports.CashManagementPermissions = void 0;
/**
 * Permission string catalog for Cash Management (Stage 13, Milestone 2
 * Part 3) — Cash Counter master, Cash Transfer (counter-to-counter
 * only, see ADR-029), and the Cash Book/Summary reports. Cashier shift
 * open/close lives under `CashierPermissions`; Bank-side actions live
 * under `BankManagementPermissions`.
 */
exports.CashManagementPermissions = {
    /** Cash Counter master CRUD. */
    CASH_COUNTER_MANAGE: 'cash-management:counter:manage',
    /**
     * List/read the Cash Counter master — split out 2026-09-23 (desk: "why
     * cash management to them?"). Every route in `cash-counter.routes.ts`,
     * including the plain list, used to gate on `CASH_COUNTER_MANAGE` alone.
     * `AppLayout`'s `CounterSelectionGate` calls that list for anyone holding
     * `financial:payment:process` — which includes a Lab Technician doing
     * IP-only charge capture, someone who has no business creating, editing
     * or deactivating a cash desk. Granting MANAGE just to clear that fetch
     * would have handed her exactly the write access she does not need.
     */
    CASH_COUNTER_VIEW: 'cash-management:counter:view',
    /** create, submit — counter-to-counter transfer. */
    CASH_TRANSFER_CREATE: 'cash-management:transfer:create',
    /** approve/reject/complete a Cash Transfer. */
    CASH_TRANSFER_APPROVE: 'cash-management:transfer:approve',
    /** Daily Cash Book, drill-down. */
    CASH_BOOK_READ: 'cash-management:cash-book:read',
    /** Cash Summary (by counter/branch/user/date). */
    CASH_SUMMARY_READ: 'cash-management:summary:read',
};
exports.ALL_CASH_MANAGEMENT_PERMISSIONS = Object.values(exports.CashManagementPermissions);
//# sourceMappingURL=cash-management.permissions.js.map